import type { A2aTransfer } from 'app-components/flux/a2aTransfers/a2aTransfersTypes';

export const A2A_TRANSFER_ENUMS = Object.freeze({
  REJECTED: 'REJECTED',
  SUBMITTED: 'SUBMITTED',
  SCHEDULED: 'SCHEDULED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
});

export const getDate = (transfer: A2aTransfer) => {
  return (
    transfer?.execution?.startedOn ||
    transfer?.execution?.cancelledOn ||
    transfer?.schedule?.startOn ||
    transfer?.execution?.failedOn ||
    ''
  );
};

export const trimDate = (transfer: A2aTransfer) => {
  const date = getDate(transfer);
  return date?.slice(0, 10);
};

export const pendingTransferTypes: string[] = [
  A2A_TRANSFER_ENUMS.SUBMITTED,
  A2A_TRANSFER_ENUMS.IN_PROGRESS,
  A2A_TRANSFER_ENUMS.SCHEDULED,
];

export const completedTransferTypes: string[] = [
  A2A_TRANSFER_ENUMS.REJECTED,
  A2A_TRANSFER_ENUMS.COMPLETED,
  A2A_TRANSFER_ENUMS.CANCELLED,
  A2A_TRANSFER_ENUMS.FAILED,
];

// IFS emergency-stops new transfers by returning this precondition-failure code; it has its own
// dedicated "transfer unavailable" UI, so it should be treated distinctly from other request failures.
export const isTransferUnavailableError = (error: unknown): boolean => {
  const data = (error as any)?.response?.data;
  return (error as any)?.response?.status === 412 && data?.errorCode === 'IFS-1005-2090';
};
